import React, { useRef, useState } from 'react'
import PropTypes from 'prop-types'
import SVG from 'react-inlinesvg'
import ReactHtmlParser from 'react-html-parser'
import ClassNames from 'classnames'

import Image from 'components/atoms/Image/Image'
import Typography from 'components/atoms/Typography/Typography'

import FileButton from 'assets/img/file-button.svg'
import ExpandIcon from 'assets/img/expand-icon.svg'
import { ModalImage, ModalDescription } from './Modals'
import './Lightbox.scss'

function Lightbox({ allImages, boxImage, children, className, image, imageAlt, index, subtitle, title }) {
  const [openDescription, setOpenDescription] = useState(false)
  const [openImage, setOpenImage] = useState(false)
  const slickRef = useRef(null)

  function handleClickImage() {
    setOpenImage(true)
    slickRef.current.slickGoTo(index, true)
  }

  return (
    <div className={ClassNames('lightbox', className)}>
      <ModalImage images={allImages} slickRef={slickRef} openState={[openImage, setOpenImage]} />
      <ModalDescription
        handleClose={() => setOpenDescription(false)}
        open={openDescription}
        subtitle={subtitle}
        title={title}
      >
        {ReactHtmlParser(children)}
      </ModalDescription>

      <button className="lightbox__image-action" onClick={handleClickImage}>
        <SVG className="lightbox__icon" src={ExpandIcon}></SVG>
        <Image
          className={ClassNames('lightbox__image mb-2', { 'lightbox__image--box': boxImage })}
          src={image}
          alt={imageAlt || title}
        />
      </button>
      {title && (
        <Typography color="green-dark-200" cssClass="lightbox__title">
          {title}
        </Typography>
      )}
      {subtitle && (
        <Typography color="green-dark-200" cssClass="lightbox__subtitle mb-2">
          {subtitle}
        </Typography>
      )}
      {children && (
        <button onClick={() => setOpenDescription(true)} aria-label={title}>
          <SVG src={FileButton} />
          <span className="sr-only">Abrir biografia</span>
        </button>
      )}
    </div>
  )
}

Lightbox.propTypes = {
  allImages: PropTypes.array,
  boxImage: PropTypes.bool,
  children: PropTypes.any,
  image: PropTypes.string.isRequired,
  imageAlt: PropTypes.string,
  onClickImage: PropTypes.func,
  subtitle: PropTypes.string,
  title: PropTypes.string,
}

export default Lightbox
